import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import EditIcon from '@mui/icons-material/Edit';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { renameScenario } from 'store/reducers/inputReducer';


/*
Renames the SCENARIO whose id it is given.

It used to dispatch renameTrial — a RUN rename — with whatever id it was
handed. Its one caller, the post-solve dialog, labels the field "Scenario Name"
and passes the open scenario's id, so the control said scenario, took a scenario
id, and asked the backend to rename a run with it. Renaming a run belongs to the
run list, which has run ids (ResultsSummaryListItems).
*/
const EditScenarioButton = (props) => {
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [editValue, setEditValue] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const theme = useTheme();
    const dispatch = useDispatch();

    const buttonStyle = {
        color: theme.palette.warning.main,
        background: theme.palette.white.main,
        pointerEvents: 'all',
        boxShadow: 'none',
        '&:hover':{
            color: theme.palette.white.main,
            backgroundColor: theme.palette.warning.main,
            pointerEvents: 'all',
        },
        ...props.buttonStyle
      }

    const handleClose = () => {
        setAnchorEl(null);
        setPopoverOpen(false);
        if (editValue && editValue !== '') {
          // Through the renameScenario thunk rather than calling the request
          // here, where it was neither awaited nor caught: its reducer says the
          // scenario was renamed, or that it wasn't and why, once.
          dispatch(renameScenario({ scenarioId: props.scenarioId, newName: editValue }));
          setEditValue('');
        }
      };

    const handleCancel = () => {
    setAnchorEl(null);
    setPopoverOpen(false);      
    }

    const handleEditTextChange = (event) => {
        setEditValue(event.target.value);
    };

  const editClick = (event) => {
    if (!popoverOpen) {
      setAnchorEl(event.currentTarget);
    }
    setPopoverOpen(!popoverOpen);
  }

    return (<>
    <Tooltip title='Edit scenario name'>
    <IconButton aria-label="Edit scenario name" sx={buttonStyle} size='xs' aria-describedby={'edit-name-' + props.scenarioId} onClick={((event) => editClick(event))}>
        <EditIcon style={{height:'0.6rem', width: '0.6rem'}} />
    </IconButton>
    </Tooltip>
    <Popover
        id={'edit-name-' + props.scenarioId}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => handleClose()}
        anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
        }}
        transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
    >
        <div style={{padding:'15px', maxWidth:'300px'}}> <TextField
                id="outlined-multiline-flexible"
                label="Scenario Name"
                multiline
                maxRows={4}
                value={editValue}
                size='small'
                onChange={handleEditTextChange}
                fullWidth
                />
            <Grid container style={{margin:'0px', paddingTop:'10px'}}>
            <Grid item xs={12} sm={8} style={{padding:'0px', paddingRight:'5px'}}>
                <Button variant={true ? "contained": "outlined"}
                    onClick={(event) => {event.stopPropagation(); handleClose()}} fullWidth
                    >
                    Save and close
                </Button>
            </Grid>
            <Grid item xs={12} sm={4} style={{padding:'0px'}}>
                <Button variant={"contained"}
                        onClick={(event) => {event.stopPropagation(); handleCancel()}} color='error'
                        fullWidth 
                >
                Cancel
                </Button>
            </Grid>
            </Grid>          
        </div>
    </Popover>
    </>
    )
}

EditScenarioButton.propTypes = {
    buttonStyle: PropTypes.object,
    scenarioId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default EditScenarioButton;
